import React, { forwardRef } from "react"

import surveyIconMapping from "./mappings/surveyIconMapping"

export const Icon = forwardRef(function Icon(
  {
    className,
    name,
    width = 40,
    height = 40,
    fill = "none",
    iconMapping = surveyIconMapping,
    ...props
  },
  ref
) {
  const IconComponent = iconMapping[name]

  if (!IconComponent) return null

  return (
    <IconComponent
      ref={ref}
      width={width}
      height={height}
      fill={fill}
      {...props}
    />
  )
})
